export { default as CouponEmptyIcon } from './ic__coupon-empty.svg';
export { default as CouponRadioIcon } from './ic__coupon-radio.svg';
export { default as RedCoupon16x16Icon } from './red_coupon_16x16.svg';
export { default as SystemCheckOutlineIcon } from '@kcd/design-system/dist/icons/ic__system__check__outline.svg';
export { default as SystemDownloadOutlineIcon } from '@kcd/design-system/dist/icons/ic__system__download__outline.svg';
